import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Field, FormikProps } from 'formik';
import { useAuth } from '../../../context/auth';
import { Label, ErrorText } from '../../CreateCampign.styles';
import { ProductName, StyledCampaignType } from './Products.styles';

export const Products = (props: FormikProps<{products: {sections: string}}>) => {
  const { authToken } = useAuth();
  const { errors, values } = props;
  const { sections } = values.products;
  const [products, setProducts] = useState<{
    id: number;
    displayName: string;
    productCode: string
  }[]>([]);
  useEffect(() => {
    if (authToken) {
      axios.get(`${process.env.REACT_APP_BASE_URL}/api/core/products/`, {headers: { DTOKEN: `${authToken}`}}).then((res) => {
        const { results } = res.data;
        setProducts(results.map((each: any) => {
          return {
            id: each.id,
            displayName: each.display_name,
            productCode: each.product_code
          }
        }));
      })
    }
  }, [authToken]);

  return (
    <>
      <Label>DoveMed Products</Label>
      {products.length > 0 && products.map(type => (
        <label key={type.productCode}>
          <StyledCampaignType active={sections.includes(type.productCode)}>
            <div>
              <Field type="checkbox" name="products.sections" value={type.productCode}/>
              <ProductName>
                {type.displayName}
                </ProductName>
            </div>
          </StyledCampaignType>
        </label>
      ))}
      <label>
        <StyledCampaignType className="moreProducts" active={false}>
          <div>
            <ProductName>
              <i>More products comming soon</i>
            </ProductName>
          </div>
        </StyledCampaignType>
      </label>
      {errors.products && <ErrorText>{errors.products.sections}</ErrorText>}
    </>
  )
};
